import React from 'react';
import {
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { FormattedMessage } from 'react-intl';

const IconTitle = ({ icon, message }) => {
  return (
    <Stack direction={'row'} spacing={1}>
      {React.isValidElement(icon)
        ? React.cloneElement(icon, { style: { fontSize: 24 } })
        : null}
      <Typography variant={'titleLarge'}>
        <FormattedMessage {...message} />
      </Typography>
    </Stack>
  );
};

export default IconTitle;
